"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _styledSystem = require("styled-system");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _glyph = _interopRequireDefault(require("../glyph"));

var _utils = require("../../utils");

var _excluded = ["isLarge"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ToolWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "tooltip-component__ToolWrapper",
  componentId: "sc-1f6jy7h-0"
})(["border-radius:50%;display:inline-flex;position:relative;align-items:center;justify-content:center;line-height:0;vertical-align:middle;"]);
var ToolGlyph = (0, _styledComponents["default"])(_glyph["default"]).withConfig({
  displayName: "tooltip-component__ToolGlyph",
  componentId: "sc-1f6jy7h-1"
})(["height:100%;"]);
var ToolButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "tooltip-component__ToolButton",
  componentId: "sc-1f6jy7h-2"
})(["cursor:pointer;&:focus{outline:none;}"]);
var ToolWindow = (0, _styledComponents["default"])(function (_ref) {
  var isLarge = _ref.isLarge,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "tooltip-component__ToolWindow",
  componentId: "sc-1f6jy7h-3"
})(["border-radius:8px;border:1px solid ", ";position:absolute;left:50%;height:150px;width:", "px;bottom:calc(0.7em + 14px);transform:translateX(-50%);z-index:10;", ";&::before{content:\"\";background:inherit;display:block;position:absolute;left:50%;bottom:-9px;height:8px;width:8px;transform-origin:0 0;border-left:1px solid ", ";border-bottom:1px solid ", ";transform:translateX(-6px) rotate(-45deg);}"], function (props) {
  return (0, _styles.colors)("border", props);
}, function (_ref2) {
  var isLarge = _ref2.isLarge;
  return isLarge ? 400 : 200;
}, _styledSystem.typography, function (props) {
  return (0, _styles.colors)("border", props);
}, function (props) {
  return (0, _styles.colors)("border", props);
});
var propTypes = {
  /** ToolWindow child components */
  children: _propTypes.node,

  /** A boolean to represent whether the tooltip is large */
  isLarge: _propTypes.bool,

  /** A boolean to represent whether the tooltip is open */
  isOpen: _propTypes.bool
};
var defaultProps = {
  isOpen: false
};

var TooltipComponent = function TooltipComponent(_ref3) {
  var children = _ref3.children,
      isLarge = _ref3.isLarge,
      shouldShow = _ref3.isOpen;

  var _useToggle = (0, _utils.useToggle)(shouldShow),
      isOpen = _useToggle[0],
      toggleIsOpen = _useToggle[1];

  return /*#__PURE__*/_react["default"].createElement(ToolWrapper, {
    forwardedAs: "span",
    height: 16,
    mx: 1,
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(ToolButton, {
    display: "inline-block",
    height: 1,
    onBlur: toggleIsOpen,
    onClick: toggleIsOpen,
    tabIndex: 0,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(ToolGlyph, {
    fill: "icon",
    id: "info"
  })), isOpen ? /*#__PURE__*/_react["default"].createElement(ToolWindow, {
    backgroundColor: "background",
    color: "text-title",
    fontSize: 2,
    forwardedAs: "span",
    isLarge: isLarge,
    lineHeight: 3,
    p: 2
  }, children) : null);
};

TooltipComponent.propTypes = propTypes;
TooltipComponent.defaultProps = defaultProps;
TooltipComponent.displayName = "Modules.TooltipComponent";
var _default = TooltipComponent;
exports["default"] = _default;